import { Box, Typography } from "@mui/material";

export const NoRowsLayout= ({ message }) => (
    <Box
        sx={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        }}
    >
        <Typography variant="body1" sx={{ color: "gray", fontWeight: 500 }}>
            {message}
        </Typography>
    </Box>
)